<template>
  <component :is="implName" />
</template>
<script>
/**
 * @module CourseSelectOnboarding 选课介绍首步：按 campusVariant 挂载 Onboarding BJ / Other
 */
export default {
  name: 'CourseSelectOnboarding',
  inject: ['$courseSelect'],
  components: {
    ImplBJ: () => import('@/views/Course/Onboarding/BJ'),
    ImplOther: () => import('@/views/Course/Onboarding/Other')
  },
  computed: {
    implName() {
      return this.$courseSelect.campusVariant === 'bj' ? 'ImplBJ' : 'ImplOther';
    }
  }
};
</script>
